import { Box, Modal, Radio, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useCommonQuery from "../../store/common/useCommonQuery";
import noPic from "../../assets/no-pic.png";

function CategoryModal({ open, handleClose, setOpen, categoryId }) {
  const [selectedId, setSelectedId] = useState("");
  const [hoveredId, setHoveredId] = useState(null);

  const { data: categoryList } = useCommonQuery.Get_category({
    search: "",
    limit: 2000,
  });

  const handleChange = (data) => {
    setSelectedId(data.id);
    handleClose(data);
  };

  useEffect(() => {
    setSelectedId(categoryId);
  }, [categoryId]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "92vw", sm: "380px" },
          background: "#ffffff",
          boxShadow: "0px 20px 60px rgba(0,0,0,0.22), 0px 4px 16px rgba(0,0,0,0.10)",
          maxHeight: "88vh",
          border: "1px solid #e4e4e4",
          overflowY: "auto",
          borderRadius: "22px",
          outline: "none",
        }}
      >
        {/* ── Header ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px 20px 12px",
            borderBottom: "1px solid #f0f0f0",
            background: "linear-gradient(135deg, #ffffff 0%, #f7fbff 100%)",
            borderRadius: "22px 22px 0 0",
            position: "sticky",
            top: 0,
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              width: 8, height: 8, borderRadius: "50%",
              background: "#2182B1", mr: "8px", flexShrink: 0,
            }}
          />
          <Typography sx={{ fontSize: "15px", fontWeight: "700", color: "#1a1a1a", letterSpacing: "0.3px" }}>
            Select Category
          </Typography>
        </Box>

        {/* ── Card list ── */}
        <Box sx={{ padding: "12px 14px 4px", display: "flex", flexDirection: "column", gap: "9px" }}>
          {categoryList?.data?.results?.map((item) => {
            const isSelected = item.id == selectedId;
            const isHovered = hoveredId === item.id;

            return (
              <div
                key={item.id}
                onClick={() => handleChange(item)}
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => setHoveredId(null)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "13px",
                  padding: "10px 12px",
                  borderRadius: "14px",
                  border: isSelected ? "1.5px solid #2182B1" : "1px solid #ececec",
                  background: isSelected
                    ? "linear-gradient(135deg, #e6f3fb 0%, #d4eaf7 100%)"
                    : isHovered ? "#f5f7f9"
                    : "linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)",
                  boxShadow: isSelected
                    ? "0 4px 16px rgba(33,130,177,0.20), 0 1px 4px rgba(33,130,177,0.10)"
                    : isHovered
                    ? "0 6px 16px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)"
                    : "0 2px 8px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
                  cursor: "pointer",
                  transition: "all 200ms ease",
                  transform: isHovered && !isSelected ? "translateY(-2px)" : "translateY(0)",
                  userSelect: "none",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                {/* ── Category icon ── */}
                <div
                  style={{
                    flexShrink: 0,
                    width: "64px",
                    height: "64px",
                    borderRadius: "12px",
                    background: isSelected ? "rgba(33,130,177,0.08)" : "rgba(0,0,0,0.03)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: isSelected ? "1px solid rgba(33,130,177,0.22)" : "1px solid #e8e8e8",
                    transition: "all 200ms ease",
                    padding: "5px",
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={item.image || noPic}
                    alt={item.name}
                    loading="lazy"
                    style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
                  />
                </div>

                {/* ── Category name ── */}
                <Typography
                  sx={{
                    flex: 1,
                    fontSize: "13.5px",
                    fontWeight: isSelected ? "700" : "600",
                    color: isSelected ? "#1a6fa0" : "#2a2a2a",
                    lineHeight: 1.35,
                    transition: "color 200ms ease",
                    wordBreak: "break-word",
                  }}
                >
                  {item.name}
                </Typography>

                {/* ── Radio ── */}
                <Radio
                  value={item.id}
                  checked={isSelected}
                  name="category-radio"
                  inputProps={{ "aria-label": item.name }}
                  sx={{
                    padding: "2px",
                    flexShrink: 0,
                    color: "#c8c8c8",
                    "&.Mui-checked": { color: "#2182B1" },
                    "& .MuiSvgIcon-root": { fontSize: "21px" },
                    transition: "color 200ms ease",
                  }}
                />
              </div>
            );
          })}
        </Box>

        {/* ── Sticky footer ── */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            background: "linear-gradient(135deg, #2182B1 0%, #1a6fa0 100%)",
            padding: "11px 16px",
            borderRadius: "0 0 22px 22px",
            mt: "8px",
          }}
        >
          <Typography sx={{ color: "rgba(255,255,255,0.92)", textAlign: "center", fontSize: "11px", lineHeight: 1.5 }}>
            If what you are looking for is not available, please select "other category"
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}

export default CategoryModal;
